<template>
  <div>
    <label v-if="label" class="form-label">{{ label }}:</label>
    <div class="relative p-0" :class="{ error: error }">
      <input ref="file" type="file" :accept="accept" class="hidden" @change="change" />
      <div v-if="!modelValue?.upload && !modelValue?.url" class="p-2">
        <button type="button" class="btn-primary font-normal text-xs px-6 py-2.5" @click="browse"><font-awesome-icon icon="fa-image-portrait" class="mr-2" /> Procurar</button>
      </div>
      <div v-else class="flex items-center justify-center p-2">
        <div class="overflow-hidden">
          <img :src="photoSelected" class="rounded-full w-32" />
          <div>{{ photoNameSelected }}</div>
          <span class="text-gray-500 text-xs">({{ photoFileSelected }})</span>
        </div>
        <button type="button" class="absolute right-0 top-0 px-4 py-1 text-white text-sm font-medium bg-red-500 hover:bg-red-700 rounded-sm" @click="remove"><font-awesome-icon icon="fa-xmark" /></button>
      </div>
    </div>
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: Object,
    label: String,
    accept: {
      type: String,
      default: 'image/*',
    },
    error: String,
  },
  emits: ['update:modelValue'],
  watch: {
    modelValue(value) {
      if (!value) {
        this.$refs.file.value = ''
      }
    },
  },
  computed: {
    photoSelected: function() {
      if(this.modelValue.upload) {
        return URL.createObjectURL(this.modelValue.upload);
      } else if(this.modelValue.url) {
        return this.modelValue.url;
      }
      return '#';
    },
    photoNameSelected: function() {
      if(this.modelValue.upload) {
        return this.modelValue.upload.name;
      } else if(this.modelValue.url) {
        return this.modelValue.name;
      }
      return '';
    },
    photoFileSelected: function() {
      if(this.modelValue.upload) {
        return this.filesize(this.modelValue.upload.size);
      } else if(this.modelValue.url) {
        return this.filesize(this.modelValue.size);
      }
      return '';
    },
  },
  methods: {
    filesize(size) {
      var i = Math.floor(Math.log(size) / Math.log(1024))
      return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i]
    },
    browse() {
      this.$refs.file.click()
    },
    change(e) {
      let model = this.modelValue;
      model.upload = e.target.files[0];
      this.$emit('update:modelValue', model)
    },
    remove() {
      let model = this.modelValue;
      model.upload = null;
      model.url = null;
      this.$emit('update:modelValue', model)
    },
  },
}
</script>
